/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */

import { useState, useEffect, } from 'react';

// @mui
// @mui
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  Switch,
  Button,
  LinearProgress
} from '@mui/material';
// swal 
// format
import FormControlLabel from '@mui/material/FormControlLabel';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';

// sections
import { AdexListHead} from '../../sections/admin/user/list';


// axios

import axios from '../../utils/axios'; 

// ----------------------------------------------------------------------

const TABLE_HEAD = [

{ id: 'app_name', label: 'APP NAME', alignRight: false },
{id: 'app_version', label: 'APP VERSION', alignRight: false},
{id: 'platform', label: 'PLATFORM', alignRight: false},
{id: 'download', label: 'DOWNLOAD', alignRight: false},

];

// ----------------------------------------------------------------------

export default function DownloadApp() {
  const { themeStretch } = useSettings();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
   const [load,SetLoad] = useState(true)
  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('id');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [dense, Setdense] = useState(false);
 

  useEffect(()  => {
  axios.get(`/api/system/app/softwarwe`).then(data => {
     setUserList(data.data?.app);
     SetLoad(false)
         }).catch(() => SetLoad(false));
  });

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };





  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

 

   

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;





  function handleChangeDense(event){
   Setdense(event.target.checked);
  }

  return (
    <Page title="App Download">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="System Apps"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'download-app' },
          ]}
        />
        <Card>
      
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table
              size={dense ? 'small' : 'medium'}
              >
                <AdexListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />

                <TableBody>
                  {userList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, app_name, app_version, platform, app_link  } = row;
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                      >
                        <TableCell align="left">{app_name}</TableCell>
                        <TableCell align="left">{app_version}</TableCell>
                        <TableCell align="left">{platform}</TableCell>
                       <TableCell align="left">
                       <Button href={app_link} target="_blank" rel="noopener" variant="contained">
        Download
      </Button>
                       </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                  
                </TableBody>

              </Table>
            </TableContainer>
          </Scrollbar>
          
          <FormControlLabel
        control={<Switch checked={dense} onChange={(event) => handleChangeDense(event)} />}
        label="Dense padding" align="left"
      />   
         
       <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, page) => setPage(page)}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
            
        </Card>
        {load && <LinearProgress sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.drawer + 1 }} />}
      </Container>
    </Page>
  );





}

// ----------------------------------------------------------------------


 



  

  